// FAR-75: the Planning Board's shell -- its tabs and its two header pills.
// Pure, so the rules are tested without a browser.

// The planning horizons. FAR-77 §4 / FAR-83 §0: Phase 1 has two tabs; the
// Weekly tab is removed (not shown, not even locked). Labels here are the
// fallback until the plan's months load ("Oct 2026 → Dec 2026").
export const TABS = [
  { key: '3month', label: 'Next 3 Months', locked: false },
  { key: '4-12month', label: 'Months 4–18', locked: false },
]

// FAR-75 §3: "Phase 1 opens on 4–18 Month (confirm)" -- Open Item 3.
export const DEFAULT_TAB = '4-12month'

// resolveTab picks the tab to show for a requested key (e.g. from the URL).
// Unknown or locked tabs fall back to the default, so a stale link (an old
// "?tab=weekly") can never open a tab that isn't available.
export function resolveTab(requested) {
  const tab = TABS.find((t) => t.key === requested)
  return tab && !tab.locked ? tab.key : DEFAULT_TAB
}

// FAR-75 §2: the Base Plan pill shows the Base Plan's name, which is its
// system-assigned creation timestamp.
export function basePlanPillLabel(basePlan, hasBasePlanId) {
  if (!hasBasePlanId) return 'Base Plan: none'
  if (!basePlan?.createdAt) return 'Base Plan: …'
  const d = new Date(basePlan.createdAt)
  if (Number.isNaN(d.getTime())) return 'Base Plan: …'
  return `Base Plan: ${d.toLocaleString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
  })}`
}

// FAR-75 §2: the Modification pill shows the plan's Modification list name.
// A plan created without a list has none yet; it still opens the panel, where
// modifications can be added (they auto-save).
export function modificationPillLabel(listName, hasListId) {
  if (!hasListId) return 'Modification: none'
  return `Modification: ${listName || '…'}`
}

// FAR-75 §2: subtitle "Folder / Production Plan name".
export function boardSubtitle(folderName, planName) {
  return [folderName, planName].filter(Boolean).join(' / ')
}
